const axios = require('axios');

/*
  Function to create native form base endpoint
*/
const createNativeFormBaseEndpoint = (locale = 'en', hostname, customFormId) =>
  `${hostname}/${locale}/native_forms/custom_forms/${customFormId}`;
/*
  Abstracts out the fetch/axios call and returns a promise
  with the values from the API call.
*/
const fetchLead = (options = {}) => {
  const { locale, customFormId, host } = options;
  if (!customFormId) {
    throw new Error('must have custom form id');
  }

  const base = createNativeFormBaseEndpoint(locale, host, customFormId);
  const url = `${base}/custom_form_entries/entry_data`;
  return axios.get(url, {
    withCredentials: true,
  });
};

/*
  Function to submit form data.
*/
const submitNativeForm = (options = {}) => {
  const {
    locale,
    customFormId,
    formData,
    host,
  } = options;

  if (!customFormId) {
    throw new Error('must have custom form id defined');
  }

  const urlParams = new URLSearchParams(window.location.search);
  const forcingFlags = urlParams.get('forced');

  return axios.post(
    `${createNativeFormBaseEndpoint(locale, host, customFormId)}/custom_form_entries.json`,
    formData,
    {
      headers: {
        'Content-type': 'application/json',
        'X-CSRF-Token': formData.authenticity_token,
      },
      withCredentials: true,
      params: {
        forced: forcingFlags,
      },
    },
  );
};

export {
  fetchLead,
  submitNativeForm,
};
